import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { down } from 'styled-breakpoints';

import { calculatePriceAfterDiscount } from '../../selectors/repair-price';

import ProgressBarControls from './progress-bar-controls';

class ProgressBar extends React.Component {
  static propTypes = {
    disableAddNewDevice: PropTypes.bool,
    disableNext: PropTypes.bool,
    groupPays: PropTypes.bool,
    nextTip: PropTypes.string,
    onCompletion: PropTypes.func,
    showCart: PropTypes.bool,
    route: PropTypes.object,
    routes: PropTypes.array,
    totalPriceAfterDiscount: PropTypes.number,
  };

  static defaultProps = {
    disableAddNewDevice: true,
    disableNext: false,
    groupPays: false,
    route: {},
    routes: [],
    totalPriceAfterDiscount: 0,
  };

  /** Takes routes and returns an array of label objects (e.g. [{label: 'Device', labelTranslated: 'Dispositivo'}]) */
  getLabels = () => {
    const { groupPays, isRutgers, routes } = this.props;

    let labelsArray = routes
      .map(obj => ({ label: obj.label, labelTranslated: obj.labelTranslated }))
      .filter(({ label }, index, labels) => {
        let isNotPaymentPage = true;
        if (groupPays) {
          isNotPaymentPage = label !== 'Payment';
        }

        return (
          labels.findIndex(item => item.label === label) === index &&
          isNotPaymentPage
        );
      });

    if (isRutgers) {
      labelsArray.splice(2, 2, 'Time', 'Location');
    }

    return labelsArray;
  };

  render() {
    const {
      groupPays,
      nextTip,
      route,
      totalPriceAfterDiscount,
      disableAddNewDevice,
      disableNext,
      showCart,
      onCompletion,
      progressNext,
      requestCost,
      requestDetails,
    } = this.props;
    return (
      <Container>
        <div className="progress-bar-container">
          <div className="progress-bar">
            {this.getLabels().reduce(
              (components, { label, labelTranslated }, index, labels) => {
                const isActive =
                  index <= labels.findIndex(item => item.label === route.label);
                if (index) {
                  components.push(
                    <Bar isActive={isActive} key={`bar-${index}`}>
                      <div className="label" />
                      <div className="line" />
                    </Bar>
                  );
                }

                return components.concat(
                  <Node isActive={isActive} key={`${label}`}>
                    <div className="label">{labelTranslated}</div>
                    <div className="dot" />
                  </Node>
                );
              },
              []
            )}
          </div>
        </div>

        <div className="progress-bar-controls-container">
          <ProgressBarControls
            disableAddNewDevice={disableAddNewDevice}
            disableNext={disableNext || !onCompletion}
            groupPays={groupPays}
            nextButton={progressNext}
            nextTip={nextTip}
            onCompletion={onCompletion}
            requestCost={requestCost}
            requestDetails={requestDetails}
            showCart={showCart}
            step={route.step}
            total={totalPriceAfterDiscount}
          />
        </div>
      </Container>
    );
  }
}

const Container = styled.div`
  height: 100%;
  align-items: center;
  display: flex;
  justify-content: space-between;

  ${down('sm')} {
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    min-height: 125px;
  }

  .progress-bar-container {
    display: flex;
    flex: 1;
    height: 100%;
    width: 100%;

    .progress-bar {
      display: flex;
      flex: 1;
      height: 100%;
      width: 100%;
      align-items: center;
    }
  }
  .progress-bar-controls-container {
    flex: 0.4;
    margin-left: 35px;
    ${down('sm')} {
      flex: 1;
    }
  }
`;

const Node = styled.div`
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  width: 1rem;
  height: 50px;
  justify-content: center;

  .label {
    color: ${props => props.theme.subText};
    font-size: 0.8em;
    font-weight: 800;
    width: 44px;
    text-align: center;
    height: 20px;

    ${down('sm')} {
      font-size: 60%;
    }
  }

  .dot {
    background-color: ${props => props.theme.background};
    border-width: 4px;
    border-style: solid;
    border-color: ${props =>
      props.isActive ? props.theme.primary : props.theme.border};
    border-radius: 100%;
    height: 1.5rem;
    width: 1.5rem;
    position: relative;
  }
`;
const Bar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100%;
  flex-direction: column;

  .label {
    height: 20px;
  }
  .line {
    display: inline-flex;
    height: 4px;
    width: 100%;
    background-color: ${props =>
      props.isActive ? props.theme.primary : props.theme.border};
  }
`;

const mapState = ({
  group: { slug, groupPays },
  pageText: {
    progress: { progressNext },
    requestCost,
    requestDetails,
  },
  payment,
  selectedDevices,
  location: { displayAddress },
  progressBar: {
    disableAddNewDevice,
    disableNext,
    onCompletion,
    showCart,
    nextTip,
  },
}) => ({
  groupPays,
  progressNext,
  requestCost,
  requestDetails,
  displayAddress,
  selectedIssues: selectedDevices.issues,
  totalPriceAfterDiscount: calculatePriceAfterDiscount({
    payment,
    selectedDevices,
  }),
  disableAddNewDevice,
  disableNext,
  onCompletion,
  showCart,
  nextTip,
});

export default connect(mapState)(ProgressBar);
